import { useCallback } from 'react'
import React from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type {
  ArrayValue,
  IArrayChangeMeta,
  IArrayControlProps,
} from 'components/uiKit/ArrayControl'
import ArrayControl from 'components/uiKit/ArrayControl'

const FieldArray = <Value extends ArrayValue>({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<IArrayControlProps<Value>, Value[]>) => {
  const handleChange = useCallback(
    (value: Value[], meta?: IArrayChangeMeta<Value>) => onChange({ name, value, meta }),
    [name, onChange],
  )

  return <ArrayControl {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldArray) as typeof FieldArray
